import * as React from "react";

// Inline SVGs matching NeuraDesigns/field-admin-app/stock.html's workflow tiles exactly.
//
// Their own module rather than Stock.js: Home renders the same three tiles and was
// importing them from a sibling *page*, which made Home depend on Stock's whole module
// just to draw an icon. The set is kept together even though two are used on one page
// only — they are one design set, and splitting them by current consumer would leave the
// next person hunting.
const ICON_PROPS = {
  width: 20,
  height: 20,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
};

export function CollectIcon(props) {
  return <svg {...ICON_PROPS} {...props}><path d="M4 7h16v13H4z" /><path d="M4 7l8-4 8 4" /><path d="M9 12h6" /></svg>;
}

// stock.html's .workflow-icon draws a QR mark for the "Scan to collect" tile that
// index.html's draws as the box above. Each page matches its own design; the
// inconsistency is the design's, not ours.
export function ScanIcon(props) {
  return (
    <svg {...ICON_PROPS} {...props}>
      <rect x="3" y="3" width="7" height="7" rx="1" /><rect x="14" y="3" width="7" height="7" rx="1" />
      <rect x="3" y="14" width="7" height="7" rx="1" /><path d="M14 14h3v3h-3zM18 18h3v3h-3z" />
    </svg>
  );
}

export function DistributeIcon(props) {
  return <svg {...ICON_PROPS} {...props}><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M23 21v-2a4 4 0 0 0-3-3.87" /><path d="M16 3.13a4 4 0 0 1 0 7.75" /></svg>;
}

export function ReturnsIcon(props) {
  return <svg {...ICON_PROPS} {...props}><path d="M3 12a9 9 0 0 1 15.5-6.3L21 8" /><path d="M3 12l2.5 2.3A9 9 0 0 0 21 12" /><path d="M21 4v4h-4" /></svg>;
}

export function CloseoutIcon(props) {
  return <svg {...ICON_PROPS} {...props}><path d="M9 11l3 3L22 4" /><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" /></svg>;
}
